module.exports = require("core-js-pure/features/instance/slice");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js/instance/slice.js
// module id = 4069
// module chunks = 25